import { call, put, takeLatest } from 'redux-saga/effects';

import { fetchOwnProfile } from 'services/users/getOwnProfile.service';

import * as actions from './profile.action';
import * as types from './profile.actionTypes';

export function* fetchProfileSaga(action: ReturnType<typeof actions.fetchProfileAsync.request>) {
	try {
		const user = (yield call(
			fetchOwnProfile,
			action.payload.userID,
			action.payload.token
		)) as Record<string, any>;
		if (!user) {
			throw new Error('no profile returned');
		}
		yield put(actions.fetchProfileAsync.success({ user }));
	} catch (error) {
		yield put(actions.fetchProfileAsync.failure({ error: (error as Error).message }));
	}
}

export default function* profileSagaWatcher() {
	yield takeLatest(types.FETCH_PROFILE_REQUEST, fetchProfileSaga);
}
